<!-- @format -->

<section
	[id]="addlData.widgetTypeTag"
	[ngClass]="{
		'hmf-mt-l hmf-mt-m-xxl': !data[0].textBoxPosition && addlData.tagSectionNum === '1'
	}">
	<div
		*ngIf="isCarousel(); else noCarousel"
		class="carousel slide carousel-fade hmf-mb-l hmf-mb-m-xxl">
		<ngb-carousel
			#carousel
			[interval]="invervalTime"
			[pauseOnHover]="true">
			<ng-template
				ngbSlide
				*ngFor="let datum of data; let i = index"
				class="carousel-template">
				<home-story
					[addlData]="addlData"
					[data]="[datum]"
					[inputPosition]="i + 1"
					[willLazyLoad]="true"></home-story>
			</ng-template>
		</ngb-carousel>
		<div class="pause-cycle-buttons position-absolute">
			<button
				tabindex="0"
				type="button"
				class="btn-customized btn-cycle d-none"
				[ngClass]="{ 'd-block': paused }"
				(click)="togglePaused()">
				<homefield-icon
					width="28px"
					height="34px"
					name="media-play"
					[ngClass]="{ 'gg-static-icon-color': isGGStaticPage }"></homefield-icon>
			</button>
			<button
				tabindex="0"
				type="button"
				class="btn-customized btn-pause"
				[ngClass]="{ 'd-none': paused }"
				(click)="togglePaused()">
				<homefield-icon
					width="28px"
					height="34px"
					name="media-pause"
					[ngClass]="{ 'gg-static-icon-color': isGGStaticPage }"></homefield-icon>
			</button>
		</div>
	</div>
	<ng-template #noCarousel>
		<home-story
			[data]="data"
			[addlData]="addlData"></home-story>
	</ng-template>
</section>
